export const UserPermissions: any = {
  ADMIN: [
    "product/:projectId",
    "product/:projectId/show",
    "product/:projectId/file/:fileId",
    "importArea",
    "master",
    "controlPanel",
    "controlPanel/product/:productId/edit",
    "search",
    "userPermissions",
    "userPermission/:permissionId/update",
    "userPermission/new",
    "banners",
    "banner/:bannerId/update",
    "banner/new",
  ],
  MKTG: [
    "product/:projectId",
    "product/:projectId/show",
    "product/:projectId/file/:fileId",
    "search",
  ],
  SUPPLIER: [
    "product/:projectId",
    "product/:projectId/show",
    "product/:projectId/file/:fileId",
    "search",
  ],
  SALES: [
    "product/:projectId",
    "product/:projectId/show",
    "product/:projectId/file/:fileId",
    "search",
  ],
  NEO: [
    "product/:projectId",
    "product/:projectId/show",
    "product/:projectId/file/:fileId",
    "search",
  ],
  NONE: [],
};

export const UserRoles = [
  "ADMIN",
  "MKTG",
  "SUPPLIER",
  "SALES",
  "PLANNING",
  "NEO",
];

export const UserRoleOptions = [
  { value: "admin", label: "Admin" },
  { value: "mktg", label: "Marketing" },
  { value: "supplier", label: "Supplier" },
  { value: "sales", label: "Sales" },
  { value: "planning", label: "Planning" },
  { value: "neo", label: "Neo" },
];

export const MediaUri = process.env.REACT_APP_MEDIA_URL;

export const mediaTypeOptions = [{ value: "PACKSHOT", label: "Pack Shot" }];

export const sortOrders = [
  "FRONT",
  "BACK",
  "RIGHT",
  "LEFT",
  "TOP",
  "BOTTOM",
  "SHINK_PAPER",
  "OTHER",
];

export const packshotImageOptions = [
  { value: "TOP", label: "Top" },
  { value: "RIGHT", label: "Right" },
  { value: "BOTTOM", label: "Bottom" },
  { value: "LEFT", label: "Left" },
  { value: "FRONT", label: "Front" },
  { value: "BACK", label: "Back" },
  { value: "SHINK_PAPER", label: "Shirnk Paper" },
  { value: "OTHER", label: "Other" },
];

export const downloadResolutionOptions = [
  { value: "ORIGINAL", label: "Original" },
  { value: "LOW", label: "Low (500p)" },
  { value: "MEDIUM", label: "Medium (1000p)" },
  { value: "HIGH", label: "High (2000p)" },
];

export enum productPackaging {
  EA = "EA",
  CASE = "CS",
  PAC = "PAC",
}

export const packagingOptions = [
  { value: "EA", label: "EA" },
  { value: "CS", label: "CASE" },
  { value: "PAC", label: "PAC" },
];

enum groupName {
  CLASS_A = "CLASS_A",
  CLASS_B = "CLASS_B",
  CLASS_C = "CLASS_C",
  CLASS_D = "CLASS_D",
}

enum groupStyle {
  CENTER = "justify-center",
  LEFT = "justify-start",
  RIGHT = "justify-end",
  BETWEEN = "justify-between",
}

export const group = {
  [groupName.CLASS_A]: {
    name: groupName.CLASS_A,
    style: groupStyle.CENTER,
  },
  [groupName.CLASS_B]: {
    name: groupName.CLASS_B,
    style: groupStyle.CENTER,
  },
  [groupName.CLASS_C]: {
    name: groupName.CLASS_C,
    style: groupStyle.CENTER,
  },
  [groupName.CLASS_D]: {
    name: groupName.CLASS_D,
    style: groupStyle.CENTER,
  },
};

export const catalogBrandOptions = [
  {
    value: { code: "FL", image: "fineline.png" },
    label: "FINELINE",
    groupName: group[groupName.CLASS_A].name,
  },
  {
    value: { code: "DN", image: "deenee.png" },
    label: "D-NEE",
    groupName: group[groupName.CLASS_A].name,
  },
  {
    value: { code: "BE", image: "benice.png" },
    label: "BENICE",
    groupName: group[groupName.CLASS_A].name,
  },
  {
    value: { code: "TS", image: "tros.png" },
    label: "TROS",
    groupName: group[groupName.CLASS_A].name,
  },
  {
    value: { code: "SM", image: "smart.png" },
    label: "SMART",
    groupName: group[groupName.CLASS_B].name,
  },
  {
    value: { code: "ES", image: "eversense.png" },
    label: "EVERSENSE",
    groupName: group[groupName.CLASS_B].name,
  },
  {
    value: { code: "TM", image: "tomi.png" },
    label: "TOMI",
    groupName: group[groupName.CLASS_B].name,
  },
  {
    value: { code: "VV", image: "vivite.png" },
    label: "VIVITE",
    groupName: group[groupName.CLASS_B].name,
  },
  {
    value: { code: "LT", image: "lovlitails.png" },
    label: "LOVLITAILS",
    groupName: group[groupName.CLASS_B].name,
  },
];

export const catalogCategoryOptions = [
  { value: { code: "cat1", image: "neo.png" }, label: "ดูแลผ้า" },
  { value: { code: "cat2", image: "neo.png" }, label: "สำหรับผู้หญิง" },
  { value: { code: "cat3", image: "neo.png" }, label: "สำหรับผู้ชาย" },
  { value: { code: "cat4", image: "neo.png" }, label: "สำหรับเด็ก" },
  {
    value: { code: "cat5", image: "neo.png" },
    label: "ดูแลความสะอาดครัวเรือน",
  },
  { value: { code: "cat6", image: "neo.png" }, label: "ดูแลผ้า สำหรับเด็ก" },
  { value: { code: "cat7", image: "neo.png" }, label: "อาบน้ำ สำหรับผู้ชาย" },
  { value: { code: "cat8", image: "neo.png" }, label: "อาบน้ำ สำหรับผู้หญิง" },
];

export const catalogTagOptions = [
  { value: { code: "tag1", image: "neo.png" }, label: "โปรคลีน" },
  { value: { code: "tag2", image: "neo.png" }, label: "ชมพู" },
  { value: { code: "tag3", image: "neo.png" }, label: "เขียว" },
  { value: { code: "tag4", image: "neo.png" }, label: "ม่วง" },
  { value: { code: "tag5", image: "neo.png" }, label: "โปรโมชั่น" },
  { value: { code: "tag6", image: "neo.png" }, label: "ถุงเติม" },
  { value: { code: "tag7", image: "neo.png" }, label: "700ml" },
  { value: { code: "tag8", image: "neo.png" }, label: "1400ml" },
];

export enum Brands {
  FINELINE = "FL",
  DNEE = "DN",
  BENICE = "BE",
  TROS = "TS",
  SMART = "SM",
  EVERSENSE = "ES",
  TOMI = "TM",
  VIVITE = "VV",
  LOVLITAILS = "LT"
}

export enum BrandsFN {
  FL = "FINELINE",
  DN = "D-NEE",
  BE = "BENICE",
  TS = "TROS",
  SM = "SMART",
  ES = "EVERSENSE",
  TM = "TOMI",
  VV = "VIVITE",
  LT = "LOVLITAILS"
}

export const brandOptions = [
  { value: "FL", label: "FINELINE" },
  { value: "DN", label: "D-NEE" },
  { value: "BE", label: "BENICE" },
  { value: "TS", label: "TROS" },
  { value: "SM", label: "SMART" },
  { value: "ES", label: "EVERSENSE" },
  { value: "TM", label: "TOMI" },
  { value: "VV", label: "VIVITE" },
  { value: "LT", label: "LOVLITAILS" },
];

export enum ProductStatus {
  NPD = "01",
  Launch = "02",
  Promotion = "03",
  Normal = "04",
  TobeDiscontinued = "05",
  Obsolete = "06",
  // Relaunch = "40"
}

export enum ProductStatusFN {
  NPD = "NPD",
  Launch = "LAUNCH",
  Promotion = "PROMOTION",
  Normal = "NORMAL",
  TobeDiscontinued = "TO BE DISCONTINUED",
  Obsolete = "OBSOLETE",
  // Relaunch = "RELAUNCH"
}

export const productStatusOptions = [
  { value: "01", label: "NPD" },
  { value: "02", label: "Launch" },
  { value: "03", label: "Promotion" },
  { value: "04", label: "Normal" },
  { value: "05", label: "To be Discontinued" },
  { value: "06", label: "Obsolete" },
  // { value: "40", label: "Relaunch" }
];

export const productSearchStatusOptions = [
  { value: "ALL", label: "All Status" },
  { value: "02", label: "Launch" },
  { value: "04", label: "Normal" },
  // { value: "40", label: "Relaunch" },
  { value: "05", label: "To be Discontinued" },
];

export enum SyncType {
  FULL = "FULL",
  INCREMENTAL = "INCREMENTAL",
}

export const bannerStatus = {
  INACTIVE: "INACTIVE",
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
  PENDING_PUBLISH: "PENDING_PUBLISH",
  HOLD: "HOLD",
  END_OF_PROMOTION: "END_OF_PROMOTION",
};

export const bannerStatusCondition = {
  [bannerStatus.INACTIVE]: { text: "Inactive", color: "text-gray-400" },
  [bannerStatus.PUBLISHED]: { text: "Published", color: "text-green-400" },
  [bannerStatus.DRAFT]: { text: "Draft", color: "text-blue-400" },
  [bannerStatus.PENDING_PUBLISH]: {
    text: "Pending Publish",
    color: "text-yellow-400",
  },
  [bannerStatus.HOLD]: { text: "Hold", color: "text-gray-400" },
  [bannerStatus.END_OF_PROMOTION]: {
    text: "End Of Promotion",
    color: "text-red-400",
  },
};
